<script setup lang="ts">
import { LucideSparkles, LucideArrowRight, LucideCheckCircle } from 'lucide-vue-next'
import { ANCHOR_IDS } from '~/lib/constants'

interface Props {
  title: string
  description: string
  buttonText: string
  target: string
}

// The bank deposits page wraps its lead form in a block with its own id
const LEAD_FORM_TARGETS: string[] = [ANCHOR_IDS.FEATURE_CREDIT_FORM_REQUEST, 'deposit-form']

const props = defineProps<Props>()
const { trackEvent } = useAnalytics()

const scrollToTarget = () => {
  const isLeadFormTarget = LEAD_FORM_TARGETS.includes(props.target)
  if (isLeadFormTarget) {
    trackEvent('lead_cta_click', { cta_location: 'scroll_button' })
  }

  const element = document.getElementById(props.target)
  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY
    const offset = 120
    const scrollToPosition = elementPosition - offset

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth'
    })
  }
}
</script>

<template>
  <SidebarBlock variant="white" class="overflow-hidden !p-0">
    <div class="relative space-y-4 p-6">
      <div class="flex items-center gap-3">
        <div
          class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-blue-600 to-purple-600"
        >
          <LucideSparkles class="h-5 w-5 text-white" />
        </div>
        <Heading :tag="'h6'">{{ title }}</Heading>
      </div>

      <div class="flex items-start gap-2">
        <LucideCheckCircle class="mt-1 h-4 w-4 flex-shrink-0 text-green-500" />
        <p>{{ description }}</p>
      </div>

      <Button class="w-full" @click="scrollToTarget">
        <span class="flex items-center justify-center gap-2">
          <span class="font-semibold">{{ buttonText }}</span>
          <LucideArrowRight class="h-4 w-4" />
        </span>
      </Button>
    </div>
  </SidebarBlock>
</template>
